import { resolver } from '@mse-reg/clients';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { rootReducer } from './root-reducer';
import { store } from './store';

export interface RootState extends ReturnType<typeof rootReducer> {}
export const useAppSelector = <T>(selector: (s: RootState) => T) => useSelector(selector);

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;

export type AppExtraArgument = {
  resolver: typeof resolver;
};

export interface AppThunkConfig {
  state: RootState;
  dispatch: ThunkDispatch<RootState, AppExtraArgument, Action>;
  extra: AppExtraArgument;
}
